module.exports = __webpack_public_path__ + "img/pastagens-selecionado.40dcf5ae.svg";